module.exports = __webpack_public_path__ + "static/media/15.e2df0ac2.jpg";